import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { verifyCurrentSession } from '../../services/sessionVerification';

export function useSessionVerification() {
  const dispatch = useDispatch();
  const token = useSelector((state: { user: { token?: string | null } }) => state.user.token);
  const userId = useSelector(
    (state: { user: { user?: { _id?: string } } }) => state.user.user?._id
  );
  useEffect(() => {
    if (!token || !userId) return;
    const check = () => {
      if (document.visibilityState === 'hidden') return;
      // Another tab may have signed in/out; reload before using its credentials with this UI.
      if (Cookies.get('token') !== token) {
        window.location.reload();
        return;
      }
      void verifyCurrentSession(dispatch);
    };
    check();
    window.addEventListener('focus', check);
    window.addEventListener('online', check);
    document.addEventListener('visibilitychange', check);
    // Covers an idle foreground POS when its socket cannot deliver a revocation event.
    const interval = window.setInterval(check, 60_000);
    return () => {
      window.removeEventListener('focus', check);
      window.removeEventListener('online', check);
      document.removeEventListener('visibilitychange', check);
      window.clearInterval(interval);
    };
  }, [dispatch, token, userId]);
}
